<template>
  <div class="iframe-wrapper">
    <iframe class="myiframe" :src="getEquifaxIframeQsURL" frameborder="0"></iframe>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'equifax-iframe-overlay',
  data() {
    return {};
  },
  computed: {
    ...mapGetters('usCredit', ['getEquifaxIframeQsURL']),
  },
};
</script>

<style lang="scss" scoped>
.iframe-wrapper {
  .myiframe {
    width: 100%;
    height: 100%;
  }
  width: 100%;
  height: 100vh;
}
</style>
